export interface PhasrRecommendationSideMenuWebComponentSchema {
  id: string;
  name: string;
  rule: string;
  ruleId: number;
  targetedActivityType: string;
  createdOn: number;
  behavioralProfiles: number;
  attackSurfaceReduction: number;
  description: string;
  mitigation: string;
  actionTaken: number;
  type: number;
  companyId: string;
  phasrUsable: boolean;
}

export enum PhasrRecommendationSideMenuWebComponentEvents {
  CANCEL = 'CloseSideMenu',
  OnRecommendationAllowAccessFromSidePanel = 'OnRecommendationAllowAccessFromSidePanel',
  OnRecommendationRestrictAccessFromSidePanel = 'OnRecommendationRestrictAccessFromSidePanel',
}
